import ReportsPageSelectionsSectionView from './reports-page-selections-section-view'

export default ReportsPageSelectionsSectionView
